// extracted by mini-css-extract-plugin
export default {"root":"iXBERkGTEAk3VQM949uL"};